import React from "react";

import styles from "./Modal.module.scss";

import ModalQuestionnary from "./ModalQuestionnary/ModalQuestionnary";
import ModalAuthReg from "./ModalAuthReg/ModalAuthReg";
import ModalFilter from "./ModalFilter/ModalFilter";

interface QuestionnareModalProps {
  mode: "questionnary";
  isActive: boolean;
  setIsChecked: (value: boolean) => void;
  setIsActive: (value: boolean) => void;
}

interface AuthRegModalProps {
  mode: "authReg";
  isActive: boolean;
  setIsActive: (value: boolean) => void;
}

interface FilterModalProps {
  mode: "filter";
  isActive: boolean;
  setIsActive: (value: boolean) => void;
}

type ModalProps = QuestionnareModalProps | AuthRegModalProps | FilterModalProps;

const Modal: React.FC<ModalProps> = (props) => {
  const mode = props.mode;

  return (
    <div className={props.isActive ? `${styles.modal} ${styles.active}` : styles.modal} onClick={() => props.setIsActive(false)}>
      <div
        style={{ minWidth: mode === "filter" ? "280px" : "400px" }}
        className={styles.modalContent}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <button className={styles.close} onClick={() => props.setIsActive(false)}>
          <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                fill="currentColor"
              ></path>
            </g>
          </svg>
        </button>
        {mode === "questionnary" ? (
          <ModalQuestionnary isActive={props.isActive} setIsChecked={props.setIsChecked} setIsActive={props.setIsActive} />
        ) : mode === "authReg" ? (
          <ModalAuthReg isActive={props.isActive} setIsActive={props.setIsActive} />
        ) : mode === "filter" ? (
          <ModalFilter isActive={props.isActive} setIsActive={props.setIsActive} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Modal;
